module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('CalendarCard', {
    attrs: {
      "value": _vm.value
    }
  }, [_c('CalendarText', {
    attrs: {
      "variant": _vm.variant
    }
  }, [(_vm.count > 0) ? [_vm._v(_vm._s(_vm.textOfCoplete)), _c('br'), _vm._v(_vm._s(_vm.count) + " " + _vm._s(_vm.pluralized))] : [_vm._v(_vm._s(_vm.nothingText))]], 2), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-296a45be","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/detail/component.vue
// module id = 59f2c6b38259911004bf
// module chunks = 0